import './App.css';
// import BasicChart from './charts/BasicChart';
import React, { useEffect } from 'react';
// import * as echarts from "echarts";
// import MapChart, { MapCA } from './charts/MapChart';
// import Splash from './pages/Splash';
// import Dashboard from './pages/Dashboard';
import WaterDashboard from './pages/ WaterDashboard';

import { useCallback, useState } from 'react';
import { ConfigProvider, } from 'antd';

function App() {
  const [view, setView] = useState(false);
  const switchView = useCallback(() => {
    setView(v => !v);
  }, [setView]);

  // useEffect(() => {
  //   echarts.registerMap('CA', MapCA);
  // }, []);

  return (
    <ConfigProvider theme={{
      token: {
        colorPrimary: 'RGB(39,78,130)'
      },
      components: {
        Cascader: {
          dropdownHeight: 240
        },
        Collapse: {
          contentPadding: 0
        },
        Table: {
          headerColor: 'RGB(156,156,156)',
          headerBg: 'transparent',
          cellPaddingInline: 0
        },
      },
    }}>
      {/* {view ?
        <Dashboard /> :
        <Splash onClick={switchView} />
      } */}
      <WaterDashboard />
    </ConfigProvider >


  );
}

export default App;


// <BasicChart
//         data=
//         {
//           [20,
//             {
//               value: 30,
//               itemStyle: {
//                 color: '#a90000'
//               }
//             },
//             40]
//         }
//         categories={['A', 'B', 'C']}
//       />

//       <MapChart />